import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
} from '@angular/core';

@Component({
  selector: 'app-onboarding-wrapper',
  templateUrl: './onboarding-wrapper.component.html',
  styleUrls: ['./onboarding-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingWrapperComponent implements AfterContentInit {
  @Input() isNarrow = false;

  footerHeight = 0;

  constructor(private cd: ChangeDetectorRef) {}

  ngAfterContentInit() {
    this.updateFooterHeight();
  }

  @HostListener('window:resize')
  private updateFooterHeight() {
    const footer = document.getElementsByTagName('app-onboarding-footer')[0];

    if (footer && footer.clientHeight !== this.footerHeight) {
      this.footerHeight = footer.clientHeight;
      this.cd.markForCheck();
    }
  }
}
